<template>
	<el-main>
		<SreBanner :dataimgs="dataimgs" />
		<SreIntro />
		<SreFunction />
		<SreArc />
		<SreScene />
		<SreAbility />
		<SreCase />
		<SreSupportPlatform />
	</el-main>
</template>

<script>
	import SreBanner from './SreBanner'
	import SreIntro from './SreIntro'
	import SreFunction from './SreFunction'
	import SreArc from './SreArc'
	import SreScene from './SreScene'
	import SreAbility from './SreAbility'
	import SreCase from './SreCase'
	import SreSupportPlatform from './SreSupportPlatform'

	export default {
		name: 'PortalSRE',
		components: {
			SreBanner,
			SreIntro,
			SreFunction,
			SreArc,
			SreScene,
			SreAbility,
			SreCase,
			SreSupportPlatform
		},
		data() {
			return {
				dataimgs: [{
					id: 0,
					title: '全方位的高效云管理平台',
					content: ['为企业提供环境中立化、运维自动化、服务自助化、数据可视化、', '成本最优化等多云环境一站式解决方案。'],
					src1: require('@/assets/images/sre-banner.png'),
					src2: require('@/assets/images/sre-banner-m.png'),
					btn: '立即体验',
					url: 'http://weitu.mopaas.com/Sre',
					platform: '感谢关注MoPaaSSRE平台，平台暂未开放公有云服务，如需试用，请联系客服。'
				}],
				sreGoal: require('@/assets/images/src_pic.png'),
				sreStatistic: [{
					id: 0,
					img: require('@/assets/images/page3Icon1.png'),
					title: '开放架构',
					content1: '各个系统之间松耦合',
					content2: '各系统内部多层架构'
				}, {
					id: 1,
					img: require('@/assets/images/page3Icon2.png'),
					title: '开放+动态',
					content1: '带来了平台灵活性和扩展性',
					content2: '满足各种运维场景的需求'
				}, {
					id: 2,
					img: require('@/assets/images/page3Icon3.png'),
					title: '动态指定',
					content1: '任意指定流程步骤',
					content2: '轻松对接生产线各项操作'
				}],
				product: [{
					id: 0,
					img1: require('@/assets/images/page4Icon11.png'),
					img2: require('@/assets/images/page4Icon12.png')
				}, {
					id: 1,
					img1: require('@/assets/images/page4Icon21.png'),
					img2: require('@/assets/images/page4Icon22.png')
				}, {
					id: 2,
					img1: require('@/assets/images/page4Icon31.png'),
					img2: require('@/assets/images/page4Icon32.png')
				}, {
					id: 3,
					img1: require('@/assets/images/page4Icon41.png'),
					img2: require('@/assets/images/page4Icon42.png')
				}, {
					id: 4,
					img1: require('@/assets/images/page4Icon51.png'),
					img2: require('@/assets/images/page4Icon52.png')
				}, {
					id: 5,
					img1: require('@/assets/images/page4Icon61.png'),
					img2: require('@/assets/images/page4Icon62.png')
				}]
			}
		}
	}
</script>

<style>

</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalSRE.vue